import { useMemo } from 'react';

import { Permission, usePermissions } from '@/shared/modules/permissions';

export type RoleAdminAccess = {
  /** The caller's own effective set — the grant-what-you-hold input. */
  heldPermissions: ReadonlySet<Permission>;
  canManage: boolean;
  canAssign: boolean;
};

export type RoleAdminPermissions = {
  /** Gates `canManage` — e.g. `EntityManageRoles`/`GammaManageRoles`. */
  manage: Permission;
  /** Gates `canAssign` — e.g. `EntityAssignRoles`/`GammaAssignRoles`. */
  assign: Permission;
};

/** UX gating only; the backend enforces these permissions independently. */
export const useRoleAdminAccess = ({ manage, assign }: RoleAdminPermissions): RoleAdminAccess => {
  const { permissions, has } = usePermissions();

  const heldPermissions = useMemo(() => new Set<Permission>(permissions), [permissions]);

  return { heldPermissions, canManage: has(manage), canAssign: has(assign) };
};
